import React, { useEffect } from 'react';
import { 
    BrowserRouter as Router,
    Switch,
    Redirect
} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { PublicRoute } from './PublicRoute';
import { PrivateRoute } from './PrivateRoute';

//import { Gestion } from '../components/gestion/Gestion';
import { AuthRouter } from './AuthRouter';
import { DashboardRoutes } from './DashboardRoutes';
import { YlmModal } from '../components/main/YlmModal';
import { startChecking, startRenovarToken } from '../actions/auth';
import { YlmModalBottom } from '../components/main/YlmModalBottom';
import { YlmModalTwoButtons } from '../components/main/YlmModalTwoButtons';
//import { Navbar } from '../components/main/Navbar';
//import { Profesionales } from '../pages/profesionales/Profesionales';

const INTERVALO_RENOVACION_TOKEN_MS = 60 * 60 * 1000;

export const AppRouter = () => {

    const dispatch = useDispatch();
    const { uid, empresa, checking } = useSelector(state => state.auth);

    useEffect(() => {
        dispatch( startChecking() );
    }, [empresa, dispatch]);

    useEffect(() => {
        const haySesionIniciada = uid !== undefined;
        if( !haySesionIniciada ) return;

        const renovarToken = () => dispatch( startRenovarToken() );
        const renovarAlVolverALaPestana = () => {
            const pestanaVisible = document.visibilityState === 'visible';
            if( pestanaVisible ) renovarToken();
        };

        const intervaloRenovacion = setInterval( renovarToken, INTERVALO_RENOVACION_TOKEN_MS );
        document.addEventListener( 'visibilitychange', renovarAlVolverALaPestana );

        return () => {
            clearInterval( intervaloRenovacion );
            document.removeEventListener( 'visibilitychange', renovarAlVolverALaPestana );
        };
    }, [uid, dispatch]);

    if( checking ){
        return <h1>Espere, por favor</h1>
    }

    // TODO: Hay que solucionar lo del router. No acepta rutas escritas a mano
    return (
        <>
        <YlmModal></YlmModal>
        <YlmModalTwoButtons></YlmModalTwoButtons>
        <YlmModalBottom></YlmModalBottom>
        <Router>
            {
                <div 
                    className={`wrapper`}
                >
                    <Switch>
                        <PublicRoute
                            path="/auth" 
                            isAuthenticated={ uid !== undefined }
                            component={ AuthRouter }
                        />
                        <PrivateRoute
                            path="/" 
                            isAuthenticated={ uid !== undefined }
                            component={ DashboardRoutes }
                        />
                        <Redirect to="/auth/login" />
                    </Switch>
                </div>
            }
        </Router>
        </>
    )
}
